import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Text, Tooltip } from '@library';
import styles from './SimpleProductTileInformation.module.css';

const SimpleProductTileInformation = ({
    comment,
    vehicleComment,
}: {
    comment?: string;
    vehicleComment?: string;
}) => {
    return (
        <Tooltip
            content={
                <div className={styles.tooltip}>
                    <Text secondary regular>
                        {comment}
                    </Text>
                    {vehicleComment && (
                        <Text secondary regular>
                            {vehicleComment}
                        </Text>
                    )}
                </div>
            }
            showArrow
        >
            <div className={styles.informationIndicator}>
                <span className={styles.info}>
                    <FormattedMessage id="more information" />
                </span>
            </div>
        </Tooltip>
    );
};

export default memo(SimpleProductTileInformation);
